import { PersonSearch } from '@mui/icons-material';
import styled from '@emotion/styled';
import { settingsTheme as t } from '../../theme';

interface EmptyStateProps {
  message: string;
}

const Wrapper = styled.div({
  padding: '64px 24px',
  textAlign: 'center',
  color: '#aab0b6',
  '& .MuiSvgIcon-root': { fontSize: 46 },
});

const Message = styled.div({
  marginTop: 12,
  fontFamily: t.font,
  fontSize: 15,
  color: t.color.muted,
});

/**
 * Primitivo: mensaje de "sin resultados" para la tabla.
 */
const EmptyState = ({ message }: EmptyStateProps) => (
  <Wrapper>
    <PersonSearch />
    <Message>{message}</Message>
  </Wrapper>
);

export default EmptyState;
